import { render, staticRenderFns } from "./Revision.vue?vue&type=template&id=7e8881b0"
import script from "./Revision.vue?vue&type=script&lang=js"
export * from "./Revision.vue?vue&type=script&lang=js"
import style0 from "./Revision.vue?vue&type=style&index=0&id=7e8881b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports